module.exports = __webpack_public_path__ + "static/media/edit-detail.979be9d7.svg";